/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.parse-float.js";
import "core-js/modules/es.array.some.js";
import "core-js/modules/es.object.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import OrderPrdItem from './components/OrderPrdItem';
import AddressDesc from './components/AddressDesc';
import OrderTop from './components/OrderTop';
import FlexCell from '@/components/FlexCell';
import OrderHandle from './components/OrderHandle';
import RefundPopup from './components/RefundPopup';
import TransferDom from "vux/src/directives/transfer-dom/index.js";
import { GetOrderDetail } from '@/api/mall';
import Public from '@/common/Public';
export default {
  data: function data() {
    return {
      orderDetail: {},
      isReal: -1,
      isUse: -1,
      address: {},
      show: false
    };
  },
  components: {
    OrderPrdItem: OrderPrdItem,
    FlexCell: FlexCell,
    AddressDesc: AddressDesc,
    OrderTop: OrderTop,
    OrderHandle: OrderHandle,
    RefundPopup: RefundPopup
  },
  directives: {
    TransferDom: TransferDom
  },
  computed: {
    price: function price() {
      var orderDetail = this.orderDetail,
          price;
      price = orderDetail.realPrice ? orderDetail.realPrice - orderDetail.freight : 0;
      price = parseFloat(price).toFixed(2);
      return price;
    }
  },
  created: function created() {
    this.getOrderDetail();
  },
  methods: {
    setShow: function setShow(val) {
      this.show = val;
    },
    //订单操作成功后的回调函数
    orderHandleDone: function orderHandleDone(status, orderNo, msg) {
      this.orderDetail.orderStatus = status;

      if (msg && msg.length > 0) {
        Public.tips({
          text: msg
        });
      }
    },
    refundPopShow: function refundPopShow(orderNo) {
      this.show = true;
    },
    //退款成功后回调
    refundConfirm: function refundConfirm(text, orderNo, data) {
      if (data) {
        Public.tips({
          text: '申请提交成功'
        });
        this.orderDetail.orderStatus = 7;
      } else {
        this.getOrderDetail();
      }

      this.show = false;
    },
    getOrderDetail: function getOrderDetail() {
      var _this = this;

      var orderNo = this.$route.query.orderNo;
      console.log(orderNo);

      if (orderNo) {
        GetOrderDetail(orderNo).then(function (data) {
          _this.orderDetail = data;
          var goods = _this.orderDetail.goods;

          if (goods.some(function (x) {
            return x.isReal == 0;
          })) {
            _this.isReal = 0;
          } else {
            _this.isReal = 1;
          }

          if (goods.some(function (x) {
            return x.isUse == 0;
          })) {
            _this.isUse = 0;
          } else {
            _this.isUse = 1;
          }

          var address = {};

          if (_this.isReal == 1) {
            address.userName = _this.orderDetail.consignee;
            address.fullAddress = _this.orderDetail.consigneeAddress;
            address.phoneNumber = _this.orderDetail.consigneeMobile;
          } else {
            address.userName = '不需要收货';
          }

          _this.address = address;
        });
      }
    },
    blur: function blur() {
      //IOS 虚拟键盘顶起内容不下
      if (Public.getSystemInfo().sysType === 1) {
        document.body.scrollTop = 0;
      }
    }
  }
};